// extracted by mini-css-extract-plugin
export default {"input":"Input_input__lz9xD","select":"Input_select__nKyf2","textarea":"Input_textarea__TuRLf"};